var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31.719,
    viewBox: "0 0 32 31.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193",
    transform: "translate(57.648 -1206.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_383",
    "data-name": "Caminho 383",
    d: "M-39.129,1307.935V1297.26s-5.4-.115-5.518-6.5,7.357-7.173,7.357-7.173,1.2-5.948,8.518-4.957,7.464,7.732,7.8,7.873,6.382.472,6.328,5.733-6.017,6.028-6.017,6.028l-.311,9.672s-4.085.3-8.624.3S-39.129,1307.935-39.129,1307.935Z",
    transform: "translate(-12 -71)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_388",
    "data-name": "Caminho 388",
    d: "M66.571,77.434c-.331,0-.6-.137-.6-.3V70.684c0-.168.269-.3.6-.3s.6.136.6.3V77.13c0,.168-.269.3-.6.3Z",
    transform: "translate(-112.998 1155.835)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_389",
    "data-name": "Caminho 389",
    d: "M66.571,77.434c-.331,0-.6-.137-.6-.3V70.684c0-.168.269-.3.6-.3s.6.136.6.3V77.13c0,.168-.269.3-.6.3Z",
    transform: "translate(-108.82 1156.835)",
    fill: "#f8f9fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.7bd84e1e898dbf798a48ee001715a773.svg";
export { ForwardRef as ReactComponent };